/**
 * Admin-only LMS data export (Excel). Allowlist is enforced in the UI only;
 * Firestore security rules must not grant broad read access to participants.
 * Prefer custom claims + rules, or a trusted backend export, for production.
 */

function parseList(raw) {
  return String(raw || '')
    .split(/[,;]/)
    .map((s) => s.trim().replace(/^["']|["']$/g, ''))
    .filter(Boolean);
}

/**
 * @param {string | null | undefined} email
 * @param {string | null | undefined} uid
 * @returns {boolean}
 */
export function isDataExportAdmin(email, uid) {
  const emails = parseList(process.env.REACT_APP_DATA_EXPORT_ADMIN_EMAILS).map((e) => e.toLowerCase());
  const uids = parseList(process.env.REACT_APP_DATA_EXPORT_ADMIN_UIDS);
  const e = (email || '').trim().toLowerCase();
  if (e && emails.includes(e)) return true;
  const id = (uid || '').trim();
  if (id && uids.includes(id)) return true;
  return false;
}

/**
 * @returns {boolean}
 */
export function isDataExportAllowlistConfigured() {
  return (
    parseList(process.env.REACT_APP_DATA_EXPORT_ADMIN_EMAILS).length > 0 ||
    parseList(process.env.REACT_APP_DATA_EXPORT_ADMIN_UIDS).length > 0
  );
}

/**
 * Emails / UIDs to omit from pilot Excel export (test accounts, staff, etc.).
 * Matches submission `userId`, row `email`, and enriched `participantEmail`.
 */
export function getDataExportExcludeLists() {
  return {
    emails: parseList(process.env.REACT_APP_DATA_EXPORT_EXCLUDE_EMAILS).map((e) => e.toLowerCase()),
    uids: parseList(process.env.REACT_APP_DATA_EXPORT_EXCLUDE_UIDS),
  };
}

export function isDataExportExcludeListConfigured() {
  const { emails, uids } = getDataExportExcludeLists();
  return emails.length > 0 || uids.length > 0;
}

/**
 * @param {Record<string, unknown>} row - raw or enriched export row
 * @returns {boolean}
 */
export function isRowExcludedFromDataExport(row) {
  const { emails, uids } = getDataExportExcludeLists();
  if (!emails.length && !uids.length) return false;

  const uid = row.userId != null ? String(row.userId).trim() : '';
  if (uid && uids.includes(uid)) return true;

  const emailFields = [row.participantEmail, row.email];
  for (const raw of emailFields) {
    const e = String(raw || '').trim().toLowerCase();
    if (e && emails.includes(e)) return true;
  }
  return false;
}
